import { queryAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const fred = defineConnector({
  identifier: "fred",
  name: "FRED",
  tagLine: "Federal Reserve economic data",
  logo,
  protocol: "http",
  tags: ["data"],
  defaultUrlPattern: () => "https://api\\.stlouisfed\\.org/.*",
  auth: (app) => queryAuth([{ name: "api_key", value: app.secret.apiKey }]),
  steps: [
    {
      title: "Request a free API key",
      items: [
        {
          kind: "markdown",
          content:
            "Create a key at [fred.stlouisfed.org](https://fred.stlouisfed.org/docs/api/api_key.html) — a free FRED account is all you need.",
        },
      ],
    },
    {
      title: "Paste your API key",
      items: [
        {
          kind: "input",
          label: "API key",
          required: true,
          target: { kind: "secrets", field: "apiKey" },
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: () => "https://api.stlouisfed.org/fred/releases?file_type=json",
  },
});
